module Meevo.Components.Mover {
    angular.module("meevo.components.mover", []);
}